import React from "react";
import { Box, Text ,Image,Heading,Flex} from "@chakra-ui/react";

const MyStats = () => {
  return (
    // <Box
    //   style={{
    //     width: "100%",
       
    //     // fontFamily: "monospace",
    //     fontSize: "15px",
    //   }}
    //   padding={{ md: "30px", base: "15px" }}
    //   id="stats"
    // >
    //     <br/>
    //     <br/>
    //   <Text
    //     // color="rgb(100,255,218)"
    //     fontSize={{ md: "35px", base: "28px" }}
    //     textAlign="center"
    //     marginLeft={{ md: "20px", base: "10px" }}
    //   >
    //     <span
    //       style={{
    //         textAlign:"center",
    //         padding: "0px",
    //         paddingTop: "5px",
    //         paddingBottom: "8px",
    //         fontSize:"2.5rem",
    //         color:"black",
    //         // fontSize: "var(--small-font-size)",
    //         fontWeight: "600"
    //       }}
    //     >
    //      Github Stats
    //     </span>
    //     <Text fontSize={"20px"} color="black">
    //         My Github Contributions
    //       </Text>
    //   </Text>

    //   <div align="center" style={{ margin: "25px" }}>
    //     <Box
    //       style={{
    //         // border: "solid brown",
    //         padding: "10px",
    //         borderRadius: "5px",
    //       }}
    //       className="react-activity-calendar"
    //     >
          
    //       <img
    //         align="center"
    //         src="https://ghchart.rshah.org/SG-Kolipyaka"
    //         alt="SG-Kolipyaka"
    //         style={{ width: "80%" }}
            
    //       />
    //     </Box>
    //     <Box
    //       style={{
    //         // border: "solid brown", 
    //         padding: "10px",
    //         borderRadius: "5px",
    //       }}
    //       id="github-stats-card"
    //     >
    //       <img
    //         src="https://camo.githubusercontent.com/522104b26efced31519d1f29ea604aa5ec752a9d4a2bab7ef293fb71483c7bab/68747470733a2f2f6769746875622d726561646d652d73746174732e76657263656c2e6170702f6170693f757365726e616d653d73672d6b6f6c697079616b612673686f775f69636f6e733d74727565266c6f63616c653d656e"
    //         alt="Sumit's Github"
    //         width={"40%"}
            
    //       />
    //     </Box>
    //     <Box
    //       style={{
    //         // border: "solid brown",
    //         padding: "20px",
    //         borderRadius: "5px",
    //       }}
    //       id="github-streak-stats"
    //     >
    //       <img
    //         src="https://camo.githubusercontent.com/1ddd734605bafddb94ffd68b4f6ab562c1f291a1a823222ffee7517211147305/68747470733a2f2f6769746875622d726561646d652d73747265616b2d73746174732e6865726f6b756170702e636f6d2f3f757365723d73672d6b6f6c697079616b6126"
    //         alt="Sumit's Github"
    //         width={"40%"}
            
    //       />
    //     </Box>
    //   </div>
    //   <br/>
    // </Box>


    <Box    
       style={{
          width: "100%",
         
          // fontFamily: "monospace",
          fontSize: "15px",
        }}
        padding={{ md: "30px", base: "15px" }}
        id="stats"
    className="react-activity-calendar">
      
            <br/>
     <br/>
    <Text
        // color="rgb(100,255,218)"
        fontSize={{ md: "35px", base: "28px" }}
        textAlign="center"
        marginLeft={{ md: "20px", base: "10px" }}
      >
        <span
          style={{
            textAlign:"center",
            padding: "0px",
            paddingTop: "5px",
            paddingBottom: "8px",
            fontSize:"2.5rem",
            color:"black",
            // fontSize: "var(--small-font-size)",
            fontWeight: "600"
          }}
        >
         Github Stats
        </span>
        <Text fontSize={"20px"} color="black">
            My Github Contributions
          </Text>
      </Text> 

    {/* <Box >
      <Heading
        display={"inline-block"}
        padding="10px"
        // bgGradient='linear(to-r, #25cefd, #f14d9f)'
        borderRadius={"15px"}
        className="tech-skill-heading"
        data-aos="fade-right"
        marginBottom={{ base: "30px", sm: "50px" }}>
        GITHUB STATISTICS & CALENDER
      </Heading>
    </Box> */}

  <div align="center" style={{ margin: "25px" }}>
        <Box
          style={{
            // border: "solid brown",
            padding: "10px",
            borderRadius: "5px",
          }}
          // className="react-activity-calendar"
        >
          
          <img
            align="center"
            src="https://ghchart.rshah.org/SG-Kolipyaka"
            alt="SG-Kolipyaka"
            style={{ width: "80%" }}
            
          />
        </Box>

    <Flex id="git-stat" flexDirection={{ base: "column", sm: "column", md: "column", lg: "row" }} width="80%" margin="auto" gap={10} >
      <Box margin={"auto"} data-aos="fade-right">

        <Image id="github-streak-stats"
          src="https://github-readme-streak-stats.herokuapp.com?user=SG-Kolipyaka&theme=react&border_radius=6.5&date_format=M%20j%5B%2C%20Y%5D"
          alt="streak-stat" />
      </Box>
      <Box margin={"auto"} data-aos="zoom-in">
        <Image id="github-stats-card"
          src="https://github-readme-stats.vercel.app/api?username=SG-Kolipyaka&count_private=true&theme=react"
          alt="stat-card" /></Box>

      <Box margin={"auto"} data-aos="fade-left">
        <Image id="github-top-langs"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=SG-Kolipyaka&theme=react"
          alt="top_languages" />
      </Box>
    </Flex>
    <br/>
    </div>
  </Box>

  );
};

export default MyStats;




// {/* <li className="nav-item">
//               <a
//                 href={Shubhangi_Saini_Resume} download={true} target='_blank'
//                 className="nav-link resume" id="resume-link-1"
//                 onClick={click ? handleClick : null}

//               >
//                 <Button id="resume-button-1" onClick={handleResume} border="1px solid white" colorScheme="pink"> Resume</Button>

//               </a>
//             </li> */}